import moment from 'moment';
import { networkErrorDispatcher } from 'flow/actions/app-actions';
import { ISO_8601_MS_RESOLUTION } from 'flow/utils';
import Actions from 'flow/actions';
import CallRecordsResource from 'flow/api/callrecords';
import { getAllCallableNumbersFromContact } from 'flow/utils/extension-utils';
import { fetchCallRecordsForExtension } from 'flow/actions/extension-actions';

export const markCallRecordAsHandled = (callRecordEntityKey) => (dispatch) => {
    const callActionDTO = {
        name: 'handle-unanswered',
        timestamp: moment().format(ISO_8601_MS_RESOLUTION),
    };

    CallRecordsResource.createCallAction(
        {
            onResult(json) {
                dispatch(receiveCallRecordAction(callRecordEntityKey, json));
            },
            onError: networkErrorDispatcher(dispatch),
        },
        callRecordEntityKey,
        callActionDTO,
    );
};

export const unmarkCallRecordAsHandled =
    (callRecordEntityKey, callActionEntityKey) => (dispatch) => {
        CallRecordsResource.deleteCallAction(
            {
                onResult() {
                    dispatch(
                        receiveDeleteCallAction(
                            callRecordEntityKey,
                            callActionEntityKey,
                        ),
                    );
                },
                onError: networkErrorDispatcher(dispatch),
            },
            callRecordEntityKey,
            callActionEntityKey,
        );
    };

export const fetchAllCallRecordsForContact =
    (extensionKey, before, contact, isBetweenAICoworkerAndBPart) =>
    (dispatch) => {
        const allCallableNumbers = getAllCallableNumbersFromContact(contact);
        if (!allCallableNumbers || allCallableNumbers.length === 0) {
            return;
        }
        allCallableNumbers.forEach((number) => {
            dispatch(
                fetchCallRecordsForExtension(
                    extensionKey,
                    ['contact', 'recordings', 'voicemessages', 'apps'],
                    null,
                    before,
                    number,
                    isBetweenAICoworkerAndBPart,
                ),
            );
        });
    };

const receiveCallRecordAction = (callRecordKey, callActionDTO) => ({
    type: Actions.RESULT_CREATE_CALL_ACTION_PERSONAL_CALL,
    callRecordKey,
    data: callActionDTO,
});

const receiveDeleteCallAction = (callRecordKey, callActionKey) => ({
    type: Actions.RESULT_DELETE_CALL_ACTION_PERSONAL_CALL,
    callRecordKey,
    callActionKey,
});
